import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  ExperienceActionRequestBodyType,
  ExperienceActionRequestPathParamsType,
  ExperienceActionResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { EXPERIMENT_ROUTES } from "../../routes/routes";
import { mpPauseExperience } from "../../utils/mixpanel";
import { useConfiguration } from "../configurations/use-configuration";
import { experienceKeys, historyKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

import { experienceAction } from "./experience-action";

export const usePauseExperience = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const shouldDuplicateProducts = useConfiguration<boolean>(
    "should_duplicate_products"
  );

  return useMutation<
    ExperienceActionResponseBodyType,
    Error,
    ApiRequest<
      ExperienceActionRequestBodyType,
      ExperienceActionRequestPathParamsType & {
        name: string;
      }
    >
  >({
    mutationKey: ["pauseExperience"],
    mutationFn: async (data) => experienceAction(data),
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey:
          data.experience?.category === "experiment"
            ? experienceKeys.experimentList
            : experienceKeys.personalizationList,
      });
      void queryClient.invalidateQueries({
        queryKey: historyKeys.one(payload.pathParams.experienceId),
      });

      // toast.success(
      //   `${
      //     data.experience?.category === "personalization"
      //       ? "Personalization"
      //       : "Experience"
      //   } Successfully Paused!`
      // );

      mpPauseExperience({
        name: payload.pathParams.name,
        id: payload.pathParams.experienceId,
      });

      if (data.experience?.id) {
        await queryClient.invalidateQueries({
          queryKey: experienceKeys.one(data.experience.id),
        });
      }

      if (
        shouldDuplicateProducts?.value &&
        data.experience?.testTypes?.hasTestPricing
      ) {
        navigate(
          `${EXPERIMENT_ROUTES.DuplicateProducts}/${payload.pathParams.experienceId}`,
          {
            state: {
              action: "pause",
            },
          }
        );
      }
    },
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          toast.info("Pausing experience...");
        } else {
          toast.error("Error pausing experience");
        }
      }
    },
  });
};
